/* eslint-disable max-lines */
import { Injectable } from '@angular/core';

import { I18nService } from '@recruitee/i18n';
import { RequisitionColumnId } from '@recruitee/requisitions-types';

import type { RequisitionsTableColumn } from '../requisitions.types';

@Injectable()
export class RequisitionsListColumnsModelService {
  public columns: RequisitionsTableColumn[] = [
    {
      id: RequisitionColumnId.Title,
      label: this.i18n.translate('app.requisitions.list.table.title'),
      visible: true,
      geometry: {
        width: 300,
        minWidth: 200,
      },
      options: {
        draggable: true,
        resizable: true,
        removable: false,
        sortable: true,
      },
    },
    {
      id: RequisitionColumnId.Guid,
      label: this.i18n.translate('app.requisitions.list.table.guid'),
      visible: false,
      geometry: {
        width: 150,
        minWidth: 100,
        maxWidth: 200,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: true,
      },
    },
    {
      id: RequisitionColumnId.Status,
      label: this.i18n.translate('app.requisitions.list.table.status'),
      visible: true,
      geometry: {
        width: 150,
        minWidth: 100,
        maxWidth: 200,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: true,
      },
    },
    {
      id: RequisitionColumnId.Department,
      label: this.i18n.translate('app.requisitions.list.table.department'),
      visible: true,
      geometry: {
        width: 110,
        minWidth: 110,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: true,
      },
    },
    {
      id: RequisitionColumnId.DateCreated,
      label: this.i18n.translate('app.requisitions.list.table.date_created'),
      visible: true,
      geometry: {
        width: 130,
        minWidth: 130,
        maxWidth: 150,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: true,
      },
    },
    {
      id: RequisitionColumnId.LocationName,
      label: this.i18n.translate('app.requisitions.list.table.location'),
      visible: true,
      geometry: {
        width: 200,
        minWidth: 100,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: false,
      },
    },
    {
      id: RequisitionColumnId.LocationAddress,
      label: this.i18n.translate('app.requisitions.list.table.location_address'),
      visible: true,
      geometry: {
        width: 200,
        minWidth: 100,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: false,
      },
    },
    {
      id: RequisitionColumnId.WorkModel,
      label: this.i18n.translate('app.requisitions.list.table.work_model'),
      visible: true,
      geometry: {
        width: 200,
        minWidth: 100,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: false,
      },
    },
    {
      id: RequisitionColumnId.State,
      label: this.i18n.translate('app.requisitions.list.table.state'),
      visible: false,
      geometry: {
        width: 200,
        minWidth: 100,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: true,
      },
    },
    {
      id: RequisitionColumnId.Jobs,
      label: this.i18n.translate('app.requisitions.list.table.jobs'),
      visible: true,
      geometry: {
        width: 200,
        minWidth: 110,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: false,
      },
    },
    {
      id: RequisitionColumnId.Followers,
      label: this.i18n.translate('app.requisitions.list.table.followers'),
      visible: false,
      geometry: {
        width: 120,
        minWidth: 120,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: false,
      },
    },
    {
      id: RequisitionColumnId.Hires,
      label: this.i18n.translate('app.requisitions.list.table.hires'),
      visible: false,
      geometry: {
        width: 200,
        minWidth: 100,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: true,
      },
    },
    {
      id: RequisitionColumnId.Recruiter,
      label: this.i18n.translate('app.requisitions.list.table.recruiter'),
      visible: false,
      geometry: {
        width: 160,
        minWidth: 120,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: true,
      },
    },
    {
      id: RequisitionColumnId.HiringManager,
      label: this.i18n.translate('app.requisitions.list.table.hiring_manager'),
      visible: false,
      geometry: {
        width: 160,
        minWidth: 120,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: true,
      },
    },
    {
      id: RequisitionColumnId.NumberOfOpenings,
      label: this.i18n.translate('app.requisitions.list.table.number_of_openings'),
      visible: true,
      geometry: {
        width: 130,
        minWidth: 130,
        maxWidth: 130,
      },
      options: {
        draggable: false,
        resizable: false,
        removable: true,
        sortable: true,
      },
    },
    {
      id: RequisitionColumnId.ReasonForOpening,
      label: this.i18n.translate('app.requisitions.list.table.reason_for_opening'),
      visible: true,
      geometry: {
        width: 200,
        minWidth: 100,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: false,
      },
    },
    {
      id: RequisitionColumnId.Requester,
      label: this.i18n.translate('app.requisitions.list.table.requester'),
      visible: false,
      geometry: {
        width: 160,
        minWidth: 120,
      },
      options: {
        draggable: false,
        resizable: true,
        removable: true,
        sortable: true,
      },
    },
    {
      id: RequisitionColumnId.Manage,
      label: this.i18n.translate('app.requisitions.list.table.manage'),
      visible: true,
      geometry: {
        width: 220,
        minWidth: 220,
        maxWidth: 220,
      },
      options: {
        draggable: false,
        resizable: false,
        removable: false,
        sortable: false,
      },
    },
  ];
  constructor(private i18n: I18nService) {}
}
